import api from '@/api';
// faq 案例等
// 创建简历
export const getFaqOption = async ({ dispatch, state, commit }, cvToken) => {
  let { cvInfo } = state;
  let res = {};
  let params = {
    cv_type: cvInfo.basic_info.cv_type,
    type: 'faqs'
  }
  res = await api.cvsEditor.getFaqOptions(params);
  if (res.code !== 1000) {
    return res;
  }
  let { faq_options } = res.data;
  commit('setFaqOptions', faq_options);
  return res;
}
